import * as React from 'react';
import { BozpDocumentNewsResponseDTO } from '../../../ApiOld/ApiServerVov';
import { Box, Grid } from '@mui/material';
import MobileDocumentItem from './Components/MobileDocumentItem';

export interface IMobileDocumentsDetailTabProps {
    data: BozpDocumentNewsResponseDTO[];
    onClick?: (doc: BozpDocumentNewsResponseDTO) => void;
    helperText?: string | undefined;
}

export default function MobileDocumentsDetailTab(props: IMobileDocumentsDetailTabProps) {
    const { data, onClick, helperText } = props;

    return (
        <Grid container sx={{ flex: 1, p: 0, height: 'calc(100vh - 145px)', display: 'flex', flexDirection: 'column' }}>
            <Grid item xs style={{ overflowY: 'auto' }}>
                {data.map((item, index) => (
                    <MobileDocumentItem
                        key={'key' + index}
                        item={item}
                        onClick={() => {
                            if (onClick) onClick(item);
                        }}
                    />
                ))}
            </Grid>
            {helperText && (
                <Grid item xs="auto">
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        textAlign={'center'}
                        sx={{ height: '60px', border: '1px solid lightgray', backgroundColor: '#f9f9f9' }}
                    >
                        {helperText}
                    </Box>
                </Grid>
            )}
        </Grid>);
}
